<div>
  <div class="flex flex-column align-items-center justify-content-center">
    <h2 class="text-center">
      Scopri le destinazioni più popolari per i tuoi
      <span class="green mr-2">viaggi di gruppo</span>
      <img src="/assets/media/icons/trending.png" />
    </h2>
    <span class="text-center grey-text">
      Sogni metropoli d'arte, avventure nella natura o relax su isole tropicali?
      I nostri viaggi di gruppo ti portano ovunque: dall'Europa all'Asia,
      dall'America Latina ai mari cristallini dell'Oceano Indiano.
    </span>
  </div>
  @if(country.length > 0){
  <div class="grid">
    <div class="col-12 md:col-4" *ngFor="let c of country">
      @if(c.medias && c.medias.length > 0){
      <a class="card" [routerLink]="url.country(c)">
        @if(loading){
        <div class="placeholder">
          <i class="pi pi-spin pi-spinner yellow text-lg"></i>
        </div>
        }@else{
        <div class="gradient"></div>
        <img [src]="c.medias![0].media | imagePipe : 'user' : 'md'" />
        <div class="title">
          <p>{{ c.name }}</p>
        </div>
        }
      </a>
      }@else{
      <a class="card bg-1" [routerLink]="url.country(c)">
        <div class="placeholder">
          @if(loading){
          <i class="pi pi-spin pi-spinner yellow text-lg"></i>
          }@else {
          <img src="/assets/media/icons/photos.png" />
          }
        </div>
        <div class="title">
          <p>{{ c.name }}</p>
        </div>
      </a>
      }
    </div>
  </div>
  }
  <div class="flex justify-content-end mt-5">
    <a routerLink="/viaggi-di-gruppo/" class="more">
      <span> Scopri tutte le destinazioni </span>
      <i class="pi pi-arrow-circle-right"></i>
    </a>
  </div>
</div>
